import mapKeys from 'lodash/mapKeys'
import mapValues from 'lodash/mapValues'
import isObject from 'lodash/isObject'
import isArray from 'lodash/isArray'
import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'

type MapKeysDeep = (obj: object, cb: (v: string, k: string) => string) => object

const mapKeysDeep: MapKeysDeep = (obj, cb) => {
  if (isArray(obj)) {
    return obj.map((innerObj) => mapKeysDeep(innerObj, cb))
  }
  if (isObject(obj)) {
    return mapValues(mapKeys(obj, cb), (val) => mapKeysDeep(val, cb))
  }
  return obj
}

/**
 * Transform an object's keys to camelCase
 * @param props The object to transform
 */
export const normalizeKeys = (props: object): object =>
  props && mapKeysDeep(props, (v: string, k: string): string => camelCase(k))

/**
 * Transform an object's keys to snake_case
 * @param props The object to transform
 */
export const snakeCaseKeys = (props: object): object =>
  props && mapKeysDeep(props, (v: string, k: string): string => snakeCase(k))

export default normalizeKeys
